module.exports = __webpack_public_path__ + "img/disliked.5d8c8ae9.png";